export const HasConfirmationOfDeleting = {

    deleteConfirmWindow() {
        const url = `${this.urlRoot}/${this.id}/delete`;
        $.ajax({
            type: 'GET',
            url: url,
            data: { class: `delete-${this.entityClass}`, id: this.id },
            success: (response) => {
                $('.modal-window-actions').css({'display': 'none'});
                $('#form-container').html(response.modal);
                $('#confirm-action-modal').modal('show');

                $(`#confirm-action-modal .delete-${this.entityClass}`).on('click', () => {
                    this.delete();
                    $('#confirm-action-modal').modal('hide');
                    $(`.data-view.customers .data-row[data-id=${this.id}]`).remove();
                });
            }
        });
    }
}
